import { Injectable } from '@angular/core';
import { Payment, TransferType } from '../models/payment';
import * as moment from 'moment';
import { TransactionReceiptModel } from '../../transfers-other-banks/transfer-response/models/trasanction-response.model';
import { PaymentResponseModel } from '../models/payment-response.model';

@Injectable()
export class PaymentReceiptsService {

	private receiptModel = new TransactionReceiptModel();

	constructor() { }

	setAgreementReceiptModel(authorized: boolean, paymentData: Payment, isToday: boolean, result?: PaymentResponseModel) {
		this.receiptModel.autorizado = authorized;
		this.receiptModel.agendado = !isToday;
		this.receiptModel.codigoBarras = paymentData.barCode;
		this.receiptModel.valor = paymentData.value;
		this.receiptModel.dataEmissao = moment(new Date()).locale('pt-BR').format();
		this.receiptModel.dataContabil = isToday ? '' : moment(paymentData.dateLabel).format('DD/MM/YYYY');
		this.receiptModel.nomeFavorecido = paymentData.paymentNameAgreement;
		this.receiptModel.tipoTransacao = TransferType.BOLETO;
		this.receiptModel.autenticacao = result.autenticacao ? result.autenticacao : '';
	}

	setCipReceiptModel(authorized: boolean, paymentData: Payment, isToday: boolean, result?: PaymentResponseModel) {
		this.receiptModel.tipoTransacao = TransferType.BOLETO;
		this.receiptModel.autorizado = authorized;
		this.receiptModel.agendado = !isToday;
		this.receiptModel.codigoBarras = paymentData.barCode;
		this.receiptModel.valor = paymentData.value;
		this.receiptModel.valorDocumento = paymentData.nominalValue || paymentData.value;
		this.receiptModel.dataVencimento = moment(paymentData.dueDateInput).format('DD/MM/YYYY');
		this.receiptModel.dataEmissao = moment(new Date()).locale('pt-BR').format();
		this.receiptModel.dataContabil = isToday ? '' : moment(paymentData.dateLabel).format('DD/MM/YYYY');
		this.receiptModel.nomeFavorecido = paymentData.assignorName;
		this.receiptModel.cpfCnpjFavorecido = paymentData.assignorCpfCnpj;
		this.receiptModel.abatimentoTitulo = paymentData.securitieRebateValue;
		this.receiptModel.encargos = paymentData.chargesValue;
		this.receiptModel.juros = paymentData.taxValue;
		this.receiptModel.multa = paymentData.fineValue;
		this.receiptModel.desconto = paymentData.discountValue;
		this.receiptModel.autenticacao = result.autenticacao ? result.autenticacao : '';
	}

	getReceiptModel(): TransactionReceiptModel {
			return this.receiptModel;
	}

	get transferType(): string {
			return this.receiptModel.tipoTransacao;
	}

	clearPaymentReceipt(): void {
		this.receiptModel = new TransactionReceiptModel();
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/payment-securities/services/payment-receipt.service.ts